/* RJ Atelier builder - part 2: state, panels, pricing, cart */
(function(){
'use strict';
var C=window.RJAT, R=window.RJATR; if(!C||!R) return;
var root=document.getElementById('rj-atelier');
var st={zoom:'detail',name:'',font:'ds',size:null,slots:[null,null,null,null],sel:2};
var POS=['Left outer','Left inner','Right inner','Right outer'];
var FONTNAMES={ds:'Style 1',ab:'Style 2',gv:'Style 3'};

function $(s){return root.querySelector(s);}
function letters(){return (st.name||'').replace(/\s/g,'').length;}
function money(c){return '\u20B9'+(Math.round(c)/100).toLocaleString('en-IN');}

function findVariant(size, nLetters, nCharms){
  var list=C.variants.filter(function(v){return v.o1===size;});
  if(C.metal==='gold'){
    for(var i=0;i<list.length;i++){
      var o=list[i].o2.toLowerCase();
      if(nLetters===0 ? o.indexOf('no name')===0 : parseInt(o,10)===nLetters) return list[i];
    }
  }else{
    list=list.filter(function(v){
      var o=v.o2.toLowerCase();
      return nCharms===0 ? o.indexOf('no')===0 : parseInt(o,10)===nCharms;
    });
    for(var j=0;j<list.length;j++){
      var o3=(list[j].o3||'').toLowerCase();
      var w = o3.indexOf('without')===0;
      if(nLetters>0 ? !w : w) return list[j];
    }
  }
  return null;
}

function charmFor(key){ return C.charm ? C.charm[C.labels[key]] : null; }

function pricing(){
  var n=letters(), cnt=st.slots.filter(Boolean).length;
  var v=findVariant(st.size,n,cnt);
  if(!v) return null;
  var total=v.price, parts=[];
  if(C.metal==='gold'){
    var base=findVariant(st.size,0,0);
    if(n>0&&base) parts.push('name '+money(v.price-base.price));
    var csum=0, ok=true;
    st.slots.forEach(function(k){ if(!k)return; var ch=charmFor(k); if(ch){csum+=ch.price;} else ok=false; });
    total+=csum;
    if(cnt>0) parts.push(cnt+(cnt>1?' charms ':' charm ')+money(csum));
    if(!ok) return {error:'charm'};
  }else{
    if(cnt>0) parts.push(cnt+(cnt>1?' charms':' charm'));
    if(n>0) parts.push('name');
  }
  return {variant:v,total:total,parts:parts};
}

function syncPrice(){
  var p=pricing(), el=$('#rjat-price'), sub=$('#rjat-pricesub'), btn=$('#rjat-atc');
  if(!p||p.error){ el.textContent='\u2014'; sub.textContent= p&&p.error==='charm' ? 'This charm is not available in gold yet.' : 'This combination is unavailable.'; btn.disabled=true; return; }
  el.textContent=money(p.total);
  sub.textContent=p.parts.length? 'Includes '+p.parts.join(' \u00B7 ') : 'Base piece \u2014 add their name and charms above';
  btn.disabled=false;
}

function syncSlots(){
  root.querySelectorAll('.rjat-slot').forEach(function(s){
    var i=+s.dataset.i, m=st.slots[i];
    s.classList.toggle('sel',st.sel===i);
    s.classList.toggle('filled',!!m);
    s.innerHTML = m ? '<img src="'+C.motifs[m]+'" alt="'+R.esc(C.labels[m])+'">' : '+';
  });
  $('#rjat-nchip').textContent=st.name||'(no name)';
}

function hasBase(){return !!C.baseURL;}
function effZoom(){ if(!hasBase()) return 'detail'; return st.zoom; }
function syncZoom(){
  var z=$('#rjat-zoom');
  z.style.display = hasBase() ? 'flex' : 'none';
  z.querySelectorAll('button').forEach(function(x){x.classList.toggle('on',x.dataset.z===effZoom());});
}
function render(){
  syncZoom();
  if(effZoom()!=='full'){R.renderDetail(st);return;}
  C.piece==='bangle'?R.renderFullBangle(st):R.renderFullChain(st);
}
function rerender(){ syncSlots(); render(); syncPrice(); }

function buildGrid(){
  var g=$('#rjat-motifs'), html='';
  C.catalog.forEach(function(k){
    html+='<div class="rjat-mot" data-m="'+k+'"><img loading="lazy" src="'+C.motifs[k]+'" alt="'+R.esc(C.labels[k])+'"></div>';
  });
  html+='<div class="rjat-mot none" data-m="">Remove</div>';
  g.innerHTML=html;
}
function buildSizes(){
  var seen={}, html='';
  C.variants.forEach(function(v){ if(!seen[v.o1]){seen[v.o1]=1; html+='<div class="rjat-sz" data-s="'+R.esc(v.o1)+'">'+R.esc(v.o1)+'</div>'} });
  $('#rjat-sizes').innerHTML=html;
  st.size=C.variants[0].o1;
  $('#rjat-sizes').firstChild.classList.add('on');
}

function toast(msg){
  var t=$('#rjat-toast'); t.textContent=msg; t.classList.add('show');
  setTimeout(function(){t.classList.remove('show');},3400);
}

function addToBag(){
  var p=pricing();
  if(!p||p.error){toast('Please adjust the design \u2014 this combination is unavailable.');return;}
  var btn=$('#rjat-atc'); btn.disabled=true; btn.classList.add('busy');
  var charms=[], props={};
  st.slots.forEach(function(k,i){ if(k) charms.push({k:k,pos:POS[i]}); });
  props['Name']=st.name||'No name';
  if(st.name) props['Letter style']=FONTNAMES[st.font];
  props['Charms']=charms.length? charms.map(function(c){return C.labels[c.k]+' ('+c.pos+')';}).join(' \u00B7 ') : 'None';
  var items=[{id:p.variant.id,quantity:1,properties:props}];
  if(C.metal==='gold'){
    charms.forEach(function(c){
      var ch=charmFor(c.k);
      items.push({id:ch.id,quantity:1,properties:{'Position':c.pos,'For':C.title+' \u2014 '+(st.name||'no name')}});
    });
  }
  fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})})
  .then(function(r){ if(!r.ok) return r.json().then(function(j){throw new Error(j.description||j.message||'error');}); return r.json(); })
  .then(function(){ window.location.href='/cart'; })
  .catch(function(e){ btn.disabled=false; btn.classList.remove('busy'); toast('Could not add to bag \u2014 '+e.message); });
}

/* wiring */
$('#rjat-zoom').addEventListener('click',function(e){
  var b=e.target.closest('button'); if(!b)return;
  st.zoom=b.dataset.z; render();
});
$('#rjat-nm').addEventListener('input',function(e){
  var v=e.target.value.replace(/[^a-zA-Z ]/g,'');
  var ls=v.replace(/\s/g,'');
  while(ls.length>8){ v=v.slice(0,-1); ls=v.replace(/\s/g,''); }
  if(v!==e.target.value)e.target.value=v;
  st.name=v.trim()||''; rerender();
});
$('#rjat-fonts').addEventListener('click',function(e){
  var p=e.target.closest('.rjat-pill'); if(!p)return;
  st.font=p.dataset.f;
  this.querySelectorAll('.rjat-pill').forEach(function(x){x.classList.toggle('on',x===p);});
  render();
});
$('#rjat-sizes').addEventListener('click',function(e){
  var s=e.target.closest('.rjat-sz'); if(!s)return;
  st.size=s.dataset.s;
  this.querySelectorAll('.rjat-sz').forEach(function(x){x.classList.toggle('on',x===s);});
  syncPrice();
});
$('#rjat-slotbar').addEventListener('click',function(e){
  var s=e.target.closest('.rjat-slot');
  if(s){ st.sel=+s.dataset.i; syncSlots(); return; }
  if(e.target.closest('.rjat-nchip')) $('#rjat-nm').focus();
});
$('#rjat-motifs').addEventListener('click',function(e){
  var m=e.target.closest('.rjat-mot'); if(!m)return;
  st.slots[st.sel]=m.dataset.m||null;
  rerender();
});
$('#rjat-atc').addEventListener('click',addToBag);
window.addEventListener('resize',render);
if(document.fonts&&document.fonts.ready){document.fonts.ready.then(render);}

buildGrid(); buildSizes(); syncSlots(); syncPrice();
R.loadBase(function(){ render(); });
render(); setTimeout(render,400); setTimeout(render,1100);
})();
